import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export type CompetencyImprovement = {
  competencyId: string;
  competencyCode: string;
  competencyName: string;
  levelGainEstimate: number;
  // Optional cap: the training brings this competency up to targetLevel at most.
  // e.g. targetLevel=3 means "effective if current score < 3; brings you up to 3".
  // null/undefined = no cap (absolute gain applies regardless of current level).
  targetLevel?: number | null;
};

export type TrainingDto = {
  id: string;
  companyId: string;
  code: string;
  name: string;
  description: string | null;
  provider: 'internal' | 'external';
  format: 'online' | 'offline' | 'blended';
  durationHours: number | null;
  competenciesImproved: CompetencyImprovement[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export async function listTrainings(companyId: string, includeInactive = false) {
  const qs = `?companyId=${companyId}${includeInactive ? '&includeInactive=true' : ''}`;
  const res = await apiFetch(`${API_BASE_URL}/api/training-catalogue${qs}`, {
    headers: JSON_HEADERS,
  });
  return res.json() as Promise<{
    success: boolean;
    data?: { trainings: TrainingDto[] };
    error?: string;
  }>;
}

export async function createTraining(input: {
  companyId: string;
  code: string;
  name: string;
  description?: string;
  provider?: 'internal' | 'external';
  format?: 'online' | 'offline' | 'blended';
  durationHours?: number;
  competenciesImproved?: CompetencyImprovement[];
}) {
  const res = await apiFetch(`${API_BASE_URL}/api/training-catalogue`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { id: string }; error?: string }>;
}

export async function updateTraining(
  id: string,
  input: {
    companyId: string;
    name?: string;
    description?: string;
    provider?: 'internal' | 'external';
    format?: 'online' | 'offline' | 'blended';
    durationHours?: number;
    competenciesImproved?: CompetencyImprovement[];
    isActive?: boolean;
  },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/training-catalogue/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}

export async function deactivateTraining(id: string, companyId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/training-catalogue/${id}?companyId=${companyId}`, {
    method: 'DELETE',
    headers: JSON_HEADERS,
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}
